import { SmartPolicyWithEntitiesFullData } from './SmartPoliciesTypes';

export const SMART_POLICY_TO_ADD: SmartPolicyWithEntitiesFullData = {
    id: -1,
    company_id: 0,
    name: '',
    alter_after: 0,
    block_after: 0,
    activated_action: [],
    update_time: new Date(),
    created_time: new Date(),
    send_to_siem: false,
    in_scope_sa: 0,
    entities: [],
    last_run: undefined,
    description: '',
    is_deleted: false,
    protect_risk_indicators: [],
    is_limit_activities: true,
    days_limit_activities: 0
};
